import { Box, Grid, Skeleton, Stack, SxProps, Typography, useTheme } from '@mui/material';
import { SmallerTextInline } from 'src/components/common/smaller-text-inline/SmallerTextInline';
import { useCustomizations } from 'src/components/utils/theme/customizations';
import { SummaryPriceLineData } from './summary-mapping';

export function SummaryPriceLine(props: { data: SummaryPriceLineData; typographySx?: SxProps }) {
    const theme = useTheme();
    const customizations = useCustomizations();

    const ticketDetailNode = props.data.ticketDetail ? (
        props.data.ticketDetailStrikeThrough ? (
            <s>{props.data.ticketDetail}</s>
        ) : (
            <>{props.data.ticketDetail}</>
        )
    ) : undefined;

    const priceFontWeight = props.data.isFree ? customizations.boldFontWeight : undefined;

    return (
        <>
            {props.data.isLoadingPrice && <SummaryPriceLineSkeleton />}
            {!props.data.isLoadingPrice && (
                <Grid container justifyContent="space-between" wrap="nowrap" pt={theme.spacing(1)}>
                    <Typography align="left" sx={props.typographySx}>
                        <Stack component="span">
                            <Box component="span">
                                {props.data.ticketName}

                                {ticketDetailNode && (
                                    <>
                                        &nbsp;
                                        <SmallerTextInline size="75%">
                                            ({ticketDetailNode})
                                        </SmallerTextInline>
                                    </>
                                )}
                            </Box>
                            {props.data.depositMessage && (
                                <SmallerTextInline size="75%" sx={{ fontStyle: 'italic' }}>
                                    {props.data.depositMessage}
                                </SmallerTextInline>
                            )}
                        </Stack>
                    </Typography>
                    <Typography align="right" sx={props.typographySx}>
                        <Stack component="span" alignItems="flex-end">
                            <Box component="span" sx={{ fontWeight: priceFontWeight }}>
                                {props.data.priceTextStrikeThrough ? (
                                    <s>{props.data.priceText}</s>
                                ) : (
                                    props.data.priceText
                                )}
                            </Box>
                            {props.data.priceSecondaryLabel && (
                                <SmallerTextInline size="75%" sx={{ fontStyle: 'italic' }}>
                                    {props.data.priceSecondaryLabel}
                                </SmallerTextInline>
                            )}
                        </Stack>
                    </Typography>
                </Grid>
            )}
        </>
    );
}

export function SummaryPriceLineSkeleton() {
    const theme = useTheme();

    return (
        <Grid container justifyContent="space-between" wrap="nowrap" pt={theme.spacing(1)}>
            <Skeleton component="span" variant="text" width="100%" animation="wave" />
        </Grid>
    );
}
